import { c as _c } from "react/compiler-runtime";
import { centsToUnits } from '@systemeio/util';
import StatisticsTabTableLayout from 'modules/funnels/funnel/components/statistics-tab/statistics-tab-table-layout';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import TabTable, { TabColumnDefinitionInterface } from 'modules/funnels/funnel/components/tab-table';
import { useFunnelStatistics } from 'modules/funnels/funnel/hooks/use-funnel-statistics';
import { FunnelStatisticsFilterInterface, FunnelStepStatisticsInterface } from 'modules/funnels/funnel/types/funnel-statistics-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import { Hint, Tooltip } from 'shared/components';
import { MobileCardHeader } from 'shared/components/table/components/mobile-card-header';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface SalesTabProps {
  funnelId: FunnelId;
}
const defaultFilters: FunnelStatisticsFilterInterface = {
  date: [null, null]
};
function StatisticsTab(t0) {
  const $ = _c(88);
  const {
    funnelId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [filter, setFilter] = useState(defaultFilters);
  let t1;
  if ($[0] !== filter || $[1] !== funnelId) {
    t1 = {
      funnelId,
      filter
    };
    $[0] = filter;
    $[1] = funnelId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    statistics
  } = useFunnelStatistics(t1);
  if (!statistics) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <TabContentLoader />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== statistics.currency || $[5] !== user?.dashboardLocale) {
    t2 = value => value ? currencyFormat(centsToUnits(value), statistics.currency, user?.dashboardLocale) : "-";
    $[4] = statistics.currency;
    $[5] = user?.dashboardLocale;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const formatCurrency = t2;
  let t3;
  if ($[7] !== t) {
    t3 = t("dashboard.funnel.sales_step");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      widthPercent: 100,
      onRender: _temp,
      onRenderSmall: _temp2,
      align: "justify-start"
    }];
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3) {
    t5 = {
      key: "funnelStepName",
      header: t3,
      widthPercent: 15,
      subHeaders: t4
    };
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("dashboard.funnel.statistics.page_views");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <span>{t6}</span>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [{
      widthPercent: 100,
      onRender: _temp3
    }];
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7) {
    t9 = {
      key: "funnelStepViews",
      header: t7,
      widthPercent: 7,
      subHeaders: t8
    };
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("dashboard.funnel.statistics.opt_in_title_hint");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("dashboard.funnel.statistics.opt_in_title");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <Hint label={t10}>{t11}</Hint>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("dashboard.funnel.statistics.all");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = {
      widthPercent: 30,
      title: t13,
      onRender: _temp4
    };
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("dashboard.funnel.statistics.conversion_rate");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15) {
    t16 = {
      widthPercent: 70,
      title: t15,
      onRender: _temp5
    };
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t14 || $[35] !== t16) {
    t17 = [t14, t16];
    $[34] = t14;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t12 || $[38] !== t17) {
    t18 = {
      key: "optIns",
      header: t12,
      widthPercent: 20,
      subHeaders: t17
    };
    $[37] = t12;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t) {
    t19 = t("dashboard.funnel.statistics.sales");
    $[40] = t;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = t("dashboard.funnel.statistics.total");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t20) {
    t21 = {
      widthPercent: 30,
      title: t20,
      onRender: _temp6
    };
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t) {
    t22 = t("dashboard.funnel.statistics.conversion_rate");
    $[46] = t;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t22) {
    t23 = {
      widthPercent: 30,
      title: t22,
      onRender: _temp7
    };
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t) {
    t24 = t("dashboard.funnel.statistics.revenue");
    $[50] = t;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== formatCurrency) {
    t25 = funnelStep_6 => {
      const revenue = formatCurrency(funnelStep_6.salesGrossSum);
      return <Tooltip mode="overflow" label={revenue}><span className="truncate font-normal">{revenue}</span></Tooltip>;
    };
    $[52] = formatCurrency;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t24 || $[55] !== t25) {
    t26 = {
      widthPercent: 30,
      title: t24,
      onRender: t25
    };
    $[54] = t24;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t21 || $[58] !== t23 || $[59] !== t26) {
    t27 = [t21, t23, t26];
    $[57] = t21;
    $[58] = t23;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t19 || $[62] !== t27) {
    t28 = {
      key: "sales",
      header: t19,
      widthPercent: 25,
      subHeaders: t27
    };
    $[61] = t19;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t) {
    t29 = t("dashboard.funnel.statistics.earning_pageview_title");
    $[64] = t;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t29) {
    t30 = <span>{t29}</span>;
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== formatCurrency) {
    t31 = [{
      widthPercent: 100,
      onRender: funnelStep_7 => {
        const earningPerView = formatCurrency(funnelStep_7.earningPerViewUnique);
        return <Tooltip mode="overflow" label={earningPerView}><span className="truncate font-normal">{earningPerView}</span></Tooltip>;
      }
    }];
    $[68] = formatCurrency;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== t30 || $[71] !== t31) {
    t32 = {
      key: "earning/preview",
      header: t30,
      widthPercent: 12,
      subHeaders: t31
    };
    $[70] = t30;
    $[71] = t31;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== t18 || $[74] !== t28 || $[75] !== t32 || $[76] !== t5 || $[77] !== t9) {
    t33 = [t5, t9, t18, t28, t32];
    $[73] = t18;
    $[74] = t28;
    $[75] = t32;
    $[76] = t5;
    $[77] = t9;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  const columns = t33;
  let t34;
  if ($[79] !== columns || $[80] !== statistics) {
    t34 = <TabTable columns={columns} data={statistics} />;
    $[79] = columns;
    $[80] = statistics;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== filter || $[83] !== statistics.commonAverageInOrder || $[84] !== statistics.commonGross || $[85] !== statistics.currency || $[86] !== t34) {
    t35 = <StatisticsTabTableLayout filter={filter} setFilter={setFilter} currency={statistics.currency} totalSales={statistics.commonGross} averageCartValue={statistics.commonAverageInOrder}>{t34}</StatisticsTabTableLayout>;
    $[82] = filter;
    $[83] = statistics.commonAverageInOrder;
    $[84] = statistics.commonGross;
    $[85] = statistics.currency;
    $[86] = t34;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  return t35;
}
function _temp7(funnelStep_5) {
  return <span className="truncate font-normal">{funnelStep_5.salesRate ? `${funnelStep_5.salesRate}%` : "-"}</span>;
}
function _temp6(funnelStep_4) {
  return <span className="truncate font-normal">{funnelStep_4.salesCount || "-"}</span>;
}
function _temp5(funnelStep_3) {
  return <span className="truncate font-normal">{funnelStep_3.optInRate}%</span>;
}
function _temp4(funnelStep_2) {
  return <span className="truncate font-normal">{funnelStep_2.optInAll}</span>;
}
function _temp3(funnelStep_1) {
  return <span className="truncate">{funnelStep_1.pageViewsUnique}</span>;
}
function _temp2(funnelStep_0) {
  return <MobileCardHeader title={funnelStep_0.name} />;
}
function _temp(funnelStep) {
  return <span className="group:justify-start text-text-primary truncate">{funnelStep.name}</span>;
}
export default StatisticsTab;